import axios from "axios";

export const FAVORITES = "v1/favorites";

export function getFavorites(page = 1, limit = 12) {
  return axios.get(`${FAVORITES}?page=${page}&limit=${limit}`);
}

export function getFavoriteIds() {
  return axios.get(`${FAVORITES}/ids`);
}

export function addFavorite(advertId) {
  return axios.post(`${FAVORITES}/${advertId}`);
}

export function removeFavorite(advertId) {
  return axios.delete(`${FAVORITES}/${advertId}`);
}
